
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export enum SupportRequestStatus {

    OPENED = "OPENED",
    CLOSED = "CLOSED",
    STALLED = "STALLED",
    RESOLVED = "RESOLVED",
    RE_OPENED = "RE_OPENED",
    UNRESOLVED = "UNRESOLVED"

}

export interface ISupportRequestParticipant {
    email: string;
    last_name: string;
    first_name: string;
    middle_name: string;
    external_id: string;
    profile_picture_location: string;
}

export interface ISupportRequest {
    title: string;
    language: string;
    request_id: string;
    created_at: string;
    platform_id: string;
    external_id: string;
    platform: ISupportPlatform;
    status: SupportRequestStatus;
    user: ISupportRequestParticipant;
    assignee: ISupportRequestParticipant;
    participants: ISupportRequestParticipant[];
}

export class SupportRequestService extends HeraBaseService {

    protected static instance: SupportRequestService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportRequestService.instance) SupportRequestService.instance = new SupportRequestService();
        return SupportRequestService.instance;
    }

    querySupportRequests(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ISupportRequest>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/support/request", { query: this.normalizeParams(params) }));
    }

    getSupportRequest(id: string): Promise<SanitizedResponse<ISupportRequest>> {
        return this.report(this.transport.get(`/hera/api/v1/support/request/${id}`));
    }

    createSupportRequest(supportRequest: Partial<ISupportRequest>): Promise<SanitizedResponse<ISupportRequest>> {
        return this.report(this.transport.post("/hera/api/v1/support/request", supportRequest));
    }

    updateSupportRequest(supportRequest: Partial<ISupportRequest>): Promise<SanitizedResponse<ISupportRequest>> {
        return this.report(this.transport.patch(`/hera/api/v1/support/request/${supportRequest.external_id}`, supportRequest));
    }

    deleteSupportRequest(id: string): Promise<SanitizedResponse<ISupportRequest>> {
        return this.report(this.transport.delete(`/hera/api/v1/support/request/${id}`));
    }

}

